module.exports = __webpack_public_path__ + "static/media/card2_3.c6473b1a.png";